class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.value = this.getVisibleSearchTerm(this.input.value);
      this.cleanDocumentTitle();
      this.input.form.addEventListener('submit', this.onStrictSearchSubmit.bind(this));
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  getVisibleSearchTerm(value) {
    const quotedMatch = value.trim().match(/^title:"((?:\\.|[^"])*)"$/i);

    if (quotedMatch) {
      return quotedMatch[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }

    return value.trim().replace(/^title:/i, '');
  }

  cleanDocumentTitle() {
    document.title = document.title.replace(/title:"([^"]+)"/gi, '$1');
  }

  setSearchOption(name, value) {
    const form = this.input.form;
    let field = Array.from(form.elements).find((element) => element.name === name);

    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }

    field.value = value;
  }

  onStrictSearchSubmit() {
    const visibleTerm = this.getVisibleSearchTerm(this.input.value).replace(/\s+/g, ' ').trim();

    if (!visibleTerm) return;

    const escapedTerm = visibleTerm.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    this.input.value = `title:"${escapedTerm}"`;
    this.setSearchOption('type', 'product');
    this.setSearchOption('options[prefix]', 'none');
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
